<template>
    <div class="course-list-section">
        <!-- 333 -->
        <!-- 3视频 -->
        <van-row @click="go_video_detail(dataItem.content, dataItem)">
            <div class="course-list-section-box">
                <div class="course-list-section-left">
                    <van-image
                        fit="cover"
                        class="course-list-section-left-img"
                        :src="dataItem.content.cover_img"
                        width="100%"
                        height="73"
                    />
                    <div class="course-list-section-left-top" v-if="dataItem.top == 1">
                        <img src="/static/bytx/tag_top.svg" alt="" />
                    </div>
                    <!-- <div v-else-if="dataItem.content.type == 1" class="course-list-section-left-zl">
                          精彩视频
                    </div> -->
                    <div v-else-if="dataItem.content.type == 2" class="course-list-section-left-zl">
                        视频专栏
                    </div>
                    <div v-else-if="dataItem.content.type == 3" class="course-list-section-left-zl">
                        精彩视频
                    </div>
                    <div class="course-list-section-left-zl play" v-else>
                        <img src="/static/bytx/list_video_play_2.svg" alt="" />
                    </div>
                </div>
                <div class="course-list-section-right">
                    <div class="course-list-section-right-title" v-html="dataItem.content.title"></div>
                    <div class="course-list-section-right-detail" v-if="dataItem.content.type == 2">
                        已更新{{ dataItem.content.current_count }}节 | 共{{ dataItem.content.total_count }}节
                    </div>
                    <div class="course-list-section-right-detail" v-else>{{ dataItem.content.view_count }}人学习</div>
                </div>
            </div>
        </van-row>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    name: 'Videos',
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
    methods: {
        getViewCount(row) {
            Interface.getData('get', `/course-phase/api/recommend_v2/${row.id}/view`)
        },
        go_video_detail(item, i) {
            if (item.type === 2) {
                this.$router.push({ name: 'video-column', params: { id: item.id } })
            } else {
                this.$router.push({ name: 'video-detail', params: { id: item.id } })
            }
            this.getViewCount(i)
            Interface.mFootPrint(i.id,67,this.contentType,1,0,0,0,item.title, this.searchText)
        }
    }
}
</script>

<style lang="scss" scoped>
.course-list-section {
    // padding: 0 15px 15px;
    padding: 10px 0px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &-box {
        width: 345px;
        padding-top: 14px;
        padding: 0px 10px;
    }

    &-left {
        width: 108px;
        height: 72px;
        float: left;
        position: relative;
        border-radius: 6px;
        &-img {
            width: 124px;
            height: 72px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            background: #10c3b5;
            border-radius: 6px 3px 3px 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 6px;
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            img {
                width: 32px;
                height: 18px;
            }

            &.play {
                width: 36px;
                height: 36px;
                border-radius: 100%;
                background: rgba(0, 0, 0, 0.3) !important;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                box-sizing: border-box;
                padding-top: 6px;
                padding-left: 7px;
                img {
                    width: 24px;
                    height: 24px;
                    border-radius: 100%;
                }
            }
        }
       &-top{
         position: absolute;
         top: 4px;
         left: 4px;
         width: 18px;
         height: 18px;
         border-radius: 3px;
         img {
           width: 18px;
           height: 18px;
           border-radius: 3px;
         }
       }
    }

    &-right {
        float: left;
        margin-left: 14px;
        width: 223px;
        text-align: left;
        &-title {
            color: #222222;
            letter-spacing: 0;
            line-height: 22px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            font-weight: 500;
            text-align: justify;
            word-break: break-all;
            padding-right: 14px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;

            .light {
                color: #0fb7ad;
            }
        }
        &-author {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #404040;
            letter-spacing: 0;
            margin-top: 4px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        &-detail {
            font-family: Avenir-Book;
            font-size: 13px;
            color: #7c7d81;
            letter-spacing: 0;
            text-align: left;
            margin-top: 8px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/videos.vue